/**
 * KiAluga — Serviço de API
 * Todas as chamadas ao backend passam por aqui
 */

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// ── Helper para obter o token guardado ────────────────────
const getToken = () => localStorage.getItem('kialuga_token');

// ── Helper principal de fetch ─────────────────────────────
const apiFetch = async (endpoint, options = {}) => {
  const token = getToken();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
    ...options,
  };

  if (config.body && typeof config.body === 'object') {
    config.body = JSON.stringify(config.body);
  }

  const response = await fetch(`${BASE_URL}${endpoint}`, config);
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.mensagem || `Erro ${response.status}`);
  }

  return data;
};

// ═══════════════════════════════════════════════════════════
// AUTH
// ═══════════════════════════════════════════════════════════
export const authAPI = {

  // Registo com email
  registar: (dados) => apiFetch('/auth/registar', {
    method: 'POST',
    body: dados,
  }),

  // Login com email
  login: (email, password) => apiFetch('/auth/login', {
    method: 'POST',
    body: { email, password },
  }),

  // Login com Google
  loginGoogle: (credential, tipo = 'cliente') => apiFetch('/auth/google', {
    method: 'POST',
    body: { credential, tipo },
  }),

  // Registo com telefone + password (sem SMS)
  registarTelefone: (nome, telefone, password, tipo) => apiFetch('/auth/telefone/registar', {
    method: 'POST',
    body: { nome, telefone, password, tipo },
  }),

  // Login com telefone + password (sem SMS)
  loginTelefone: (telefone, password) => apiFetch('/auth/telefone/login', {
    method: 'POST',
    body: { telefone, password },
  }),

  // Enviar OTP para verificar número no perfil (não é login)
  enviarOtp: (telefone) => apiFetch('/auth/telefone/enviar', {
    method: 'POST',
    body: { telefone },
  }),

  // Verificar OTP (perfil)
  verificarOtp: (userId, codigo, nome, tipo) => apiFetch('/auth/telefone/verificar', {
    method: 'POST',
    body: { userId, codigo, nome, tipo },
  }),

  // Obter perfil
  perfil: () => apiFetch('/auth/perfil'),

  // Guardar sessão
  guardarSessao: (token, utilizador) => {
    localStorage.setItem('kialuga_token',      token);
    localStorage.setItem('kialuga_utilizador', JSON.stringify(utilizador));
  },

  // Terminar sessão
  logout: () => {
    localStorage.removeItem('kialuga_token');
    localStorage.removeItem('kialuga_utilizador');
  },

  // Obter utilizador guardado
  utilizadorAtual: () => {
    try {
      return JSON.parse(localStorage.getItem('kialuga_utilizador'));
    } catch {
      return null;
    }
  },

  // Verificar se está logado
  estaLogado: () => !!getToken(),
};

// ═══════════════════════════════════════════════════════════
// ANÚNCIOS
// ═══════════════════════════════════════════════════════════
export const anunciosAPI = {

  listar: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiFetch(`/anuncios${query ? '?' + query : ''}`);
  },

  detalhe: (id) => apiFetch(`/anuncios/${id}`),

  criar: (dados) => apiFetch('/anuncios', {
    method: 'POST',
    body: dados,
  }),

  meusAnuncios: () => apiFetch('/fornecedor/anuncios'),

  categorias: () => apiFetch('/anuncios/categorias'),
};

// ═══════════════════════════════════════════════════════════
// RESERVAS
// ═══════════════════════════════════════════════════════════
export const reservasAPI = {

  criar: (dados) => apiFetch('/reservas', {
    method: 'POST',
    body: dados,
  }),

  minhasReservas: () => apiFetch('/cliente/reservas'),

  reservasFornecedor: () => apiFetch('/fornecedor/reservas'),

  actualizarEstado: (id, estado) => apiFetch(`/reservas/${id}/estado`, {
    method: 'PATCH',
    body: { estado },
  }),
};

// ═══════════════════════════════════════════════════════════
// SAÚDE DO BACKEND
// ═══════════════════════════════════════════════════════════
export const healthCheck = () => apiFetch('/health');

// ═══════════════════════════════════════════════════════════
// PERFIL & KYC
// ═══════════════════════════════════════════════════════════
export const perfilAPI = {
  obter:     ()      => apiFetch('/perfil'),
  actualizar:(dados) => apiFetch('/perfil', { method:'PUT', body: dados }),
  mudarPassword: (dados) => apiFetch('/perfil/password', { method:'PUT', body: dados }),

  uploadAvatar: (file) => {
    const fd = new FormData();
    fd.append('avatar', file);
    return fetch(`${BASE_URL}/perfil/avatar`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getToken()}` },
      body: fd,
    }).then(r => r.json());
  },

  submeterKyc: (biNumero, biFoto, selfie) => {
    const fd = new FormData();
    fd.append('bi_numero', biNumero);
    fd.append('bi_foto',   biFoto);
    fd.append('selfie',    selfie);
    return fetch(`${BASE_URL}/perfil/kyc`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getToken()}` },
      body: fd,
    }).then(r => r.json());
  },
};
